import styled from 'styled-components';


export const EntInfosContainer = styled.div`
    width: 100%;
    font-size: 0.9rem;
    margin-top: 1rem;
`;

export const FormSelect = styled.select`
 background: white;
  border: none;
  outline: none;
  /* min-width: 170px; */
  flex: 1;
  text-align: right;
  color: #505050;
`;

export const FormInputAgence = styled.input`
  /* flex: 1; */
  border: none;
  outline: none;
  flex: 1;
  /* width: 170px; */
  text-align: right;
  color: #505050;
  font-size: 0.8rem;
  ${({ err, theme }) => !err && "border-bottom: 1px solid #EE5A5A"} ;
  /* border-bottom:1px solid #EE5A5A; */
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
    font-style: italic;
  }
`;

export const EntHeaderTitle = styled.h4`
font - size: 1.2rem;
font - weight: normal;
color: ${ ({ theme }) => theme.colors.primary };
`

export const EICol = styled.div`
  width: 350px;
    display: none;
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    z-index: 2000;
    height:fit-content ;
    background-color: white;

    /* overflow: auto; */
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 0.25rem;

    &:before {
        content: "";
        position: absolute;
        top: -16px;
        left: 10px;
        transform: translateX(-50%);
        border: 7px solid;
        /* border-color: transparent transparent #e9ecef transparent; */
        border-color: transparent transparent #e9ecef transparent;
    }
`

export const IconDiv = styled.div`
 position: relative;
   
&:hover ${EICol} {
        display: block;
    }
`





